module.exports = __webpack_public_path__ + "img/information-6255.fccb37e2.svg";